export default __webpack_public_path__ + "static/media/hinh-nho-1.08700399.jpeg";